import React, { useContext } from 'react'

import { AddColumnDialog, ColumnForm } from '@pages/EntityCreateOrEdit'

import { MODEL_TYPE } from '@constants'

import { getColumnDialogScript } from '../../helpers'
import { PageContext } from '../../TimeLineCreateOrEdit'

export const ObjectYAddColumnDialog = () => {
  const { handlers: contextHandlers, state: contextState } = useContext(PageContext)
  const { handleCloseObjectYAddColumnDialog, handleChangeObjectYColumns, handleSaveTimeLine } =
    contextHandlers
  const {
    objectYShowAddColumnDialog,
    objectYAddColumnDialogData,
    watchObjectYObject,
    watchObjectXObject,
    watchVariables,
    isCreateOrUpdateLoading,
  } = contextState

  const handleCreateColumn = (data: ColumnForm) => {
    handleChangeObjectYColumns(data)

    return handleSaveTimeLine()
  }

  const handleUpdateColumn = (data: ColumnForm) => {
    handleChangeObjectYColumns(data)

    return handleSaveTimeLine()
  }

  if (objectYAddColumnDialogData) {
    return (
      <AddColumnDialog
        {...objectYAddColumnDialogData}
        isAllowPinningAllColumns
        loading={isCreateOrUpdateLoading}
        showDialog={objectYShowAddColumnDialog}
        type={MODEL_TYPE.TIMELINE_OBJECT_Y_COLUMN}
        jsJSXHint={getColumnDialogScript({
          objectX: watchObjectXObject,
          objectY: watchObjectYObject,
          variables: watchVariables,
        })}
        onCloseModal={handleCloseObjectYAddColumnDialog}
        onCreateColumn={handleCreateColumn}
        onUpdateColumn={handleUpdateColumn}
      />
    )
  }

  return null
}
